import { useNavigate } from 'react-router';
import OperationalStatCard from './components/operational-stat-card';
import QuickActionsCard from './components/quick-actions-card';
import { useOperationalViewSummary } from './useOperationalViewSummary';
import { operationalViewCardsConfig } from './operational-view-cards.config';
import { useI18nState } from '../../../stores/settings/language-context';
import { useHomeStore } from '../../../stores/home-store';
import './operational-view.scss';

export default function OperationalView() {
  const { cards, isLoading } = useOperationalViewSummary();
  const { localeData } = useI18nState();
  const navigate = useNavigate();
  const [fromDate] = useHomeStore(store => store.fromDate);
  const [toDate] = useHomeStore(store => store.toDate);
  const [dateFilterType] = useHomeStore(store => store.dateFilterType);

  return (
    <div className="operational-view-grid" data-testid="operational_view">
      {cards.map(card => (
        <OperationalStatCard
          key={card.cardType}
          title={card.title}
          icon={card.icon}
          sections={card.sections}
          isLoading={isLoading}
          onSectionClick={(sectionKey: string) => {
            const section = card.sections.find(s => s.key === sectionKey);
            const tabKey = section?.tabKey ?? 'all';
            // workItem lives on the config, not on the resolved card data (which only carries
            // display-ready section values) - look it back up to build the drill-down params.
            const workItem = operationalViewCardsConfig[card.cardType]?.sections.find(
              s => s.key === sectionKey
            )?.workItem;

            const params = new URLSearchParams({ tab: tabKey });
            if (workItem) {
              params.set('fromDate', fromDate.toISOString());
              params.set('toDate', toDate.toISOString());
              params.set('dateFilterType', String(dateFilterType));
            }

            navigate(`${card.routePath}?${params.toString()}`, {
              state: {
                breadCrumbLinks: [
                  { title: localeData.Home, path: '/home' },
                  { title: card.breadcrumbLabel }
                ]
              }
            });
          }}
        />
      ))}
      <QuickActionsCard />
    </div>
  );
}
